import { roundAtDecimals } from 'common/Utils/NumberUtilities'
import { PartConfigTranslations } from 'common/Utils/PartConfigTranslations'
import PartThumbnail from 'components/Common/PartThumbnail'
import PropTypes from 'prop-types'
import React from 'react'
import { withTranslation } from 'react-i18next'
import { connect } from 'react-redux'

const DetailPartProduction = ({ item, t, partConfigOptions, index }) => {
	const material = PartConfigTranslations.getMaterialName({ part: item.part, partConfigOptions, language: 'es' })
	const finish = PartConfigTranslations.getFinishName({ part: item.part, partConfigOptions, language: 'es' })
	const isFirstItem = index == 0
	return (
		<>
			<div
				key={`${item.displayId}_`}
				className={'w-100 mb-1 rounded d-flex flex-row align-items-center'}
			>
				<span className='mx-4'></span>
				<span className='col-2 d-flex flex-column'>
					{isFirstItem && <span style={{ fontWeight: 'bold' }}>{t('partId', { ns: 'naming' })}</span>}
					<span className='mt-5'>
						{item.part.id}
					</span>
				</span>
				<span className='col-2 d-flex flex-column'>
					<span className='mt-4 mb-1'>
						<PartThumbnail
							geometryData={{
								partId: item.part.id,
								partName: item.part.name,
								size: item.part.size,
								weight: item.part.weight,
							}}
							itsSmallest={true}
						/>
					</span>
				</span>
				<div className='d-flex flex-column col-2'>
					{isFirstItem && <span className='mb-4' style={{ fontWeight: 'bold' }}>{t('description', { ns: 'naming' })}</span>}
					<span>{item.part.name}</span>
					<span style={{}}>{material} - {finish}</span>
				</div>
				<span className='col-2 d-flex flex-column align-items-center'>
					{isFirstItem && <span style={{ marginBottom: '25px', fontWeight: 'bold' }}>{t('unitPrice', { ns: 'naming' })}</span>}
					<span style={{ marginBottom: '16px' }}>{item.unitPurchasePrice} €</span>
				</span>
				<span className='col-2 d-flex flex-column align-items-center'>
					{isFirstItem && <span style={{ marginBottom: '25px', fontWeight: 'bold' }}>{t('shippedQuantity', { ns: 'naming' })}</span>}
					<span style={{ marginBottom: '16px', }}>{item.shippedQuantity}</span>
				</span>
				<span className='d-flex flex-column align-items-center'>
					{isFirstItem && <span style={{ marginBottom: '25px', fontWeight: 'bold' }}>{t('total', { ns: 'naming' })}</span>}
					<span style={{ marginBottom: '16px' }}>{roundAtDecimals(item.unitPurchasePrice * item.shippedQuantity, 2)} €</span>
				</span>
			</div>
		</>
	)
}

DetailPartProduction.propTypes = {
	item: PropTypes.object,
	i18n: PropTypes.object,
	index: PropTypes.number,

}

const mapStateToProps = (state) => ({
	partConfigOptions: state.Parts.partConfigOptions,

})

const mapDispatchToProps = {}

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(DetailPartProduction))
